import PropTypes from "prop-types"
import React from "react"
import { connect } from "react-redux"
import withRouter from "components/Common/withRouter"

//i18n
import { withTranslation } from "react-i18next"
import SidebarContent from "./SidebarContent"

import { Link } from "react-router-dom"

import logo from "../../assets/images/3logo.png"
import logoLightPng from "../../assets/images/3logo.png"
import logoLightSvg from "../../assets/images/3logo.png"
import logoDark from "../../assets/images/3logo.png"
import logoSa from "../../assets/images/30thAnnivery_SATS_logo-512px.png"

const Sidebar = props => {
  return (
    <React.Fragment>
      <div className="vertical-menu">
        <div
          className="navbar-brand-box p-0 pt-xl-3 
pt-lg-3  pt-sm-0 "
        >
          <Link to="/home" className="logo logo-dark">
            <span className="logo-sm ">
              <img src={logoSa} alt="" height="50" />
            </span>
            <span className="logo-lg ">
              <img src={logoSa} alt="" height="100" />
            </span>
          </Link>

          <Link
            to="/home"
            className="logo logo-light p-0 pt-xl-3 
  pt-lg-3 pt-sm-0  "
          >
            <span className="logo-sm ">
              <img src={logoSa} alt="" height="50" />
            </span>
            <span className="logo-lg ">
              <img src={logoSa} alt="" height="100" />
            </span>
          </Link>
        </div>
        <div data-simplebar className="h-100">
          {props.type !== "condensed" ? <SidebarContent /> : <SidebarContent />}
        </div>
        <div className="sidebar-background"></div>
      </div>
    </React.Fragment>
  )
}

Sidebar.propTypes = {
  type: PropTypes.string,
}

const mapStatetoProps = state => {
  return {
    layout: state.Layout,
  }
}
export default connect(
  mapStatetoProps,
  {}
)(withRouter(withTranslation()(Sidebar)))
